import {Deserializable} from "./deserializable.model";

export class JobSubjectDocument {

job_subject_document_id: number;
job_id: number;
subject_id: any;
display_order: number;
display_order_letter?: string;
page_count: number;
job_number: string;
subject_number: string;
subject_name: string;
document_name: string;

/*
job_subject_documents_id
job_id
subject_id
order
page_count
job_number
subject_number
subject_name
document_name
*/

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobSubjectDocument {
    Object.assign(this, input);

    return this;
  }


}



